import axiosInstance from "../utils/axios";

export const createGameAPI = async (payload: any) => {
  try {
    const response = await axiosInstance.post("/api/user/game/create", payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error creating game:", error);
    throw new Error(error.response?.data?.message || "Failed to create game");
  }
};

export const getGameListAPI = async () => {
  try {
    const response = await axiosInstance.get("/api/user/game/played_games");
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error getting game list:", error);
    throw new Error(error.response?.data?.message || "Failed to get game list");
  }
};

export const getGameDetailsAPI = async (gameId: string) => {
  // console.log("calllllll", gameId);
  try {
    const response = await axiosInstance.get(`/api/user/game/game-details/${gameId}`);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error getting game details:", error);
    throw new Error(error.response?.data?.message || "Failed to get game details");
  }
};

interface UpdateAnswerPayload {
  game_id: string;
  question_id: string;
  team_id?: string | null;
  user_id: string | null | string[];
}

export const updateAnswerAPI = async (payload: UpdateAnswerPayload) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/update-answer`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error updating answer:", error);
    throw new Error(error.response?.data?.message || "Failed to update answer");
  }
};

export const endGameAPI = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/end`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error ending game:", error);
    throw new Error(error.response?.data?.message || "Failed to end game");
  }
};

export const pauseGameAPI = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/pause`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error ending game:", error);
    throw new Error(error.response?.data?.message || "Failed to end game");
  }
};
interface ResumeGamePayload {
  game_id: string;
}
export const resumeGameAPI = async (payload: ResumeGamePayload) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/resume`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error resuming game:", error);
    throw new Error(error.response?.data?.message || "Failed to resume game");
  }
};

export const getLifelinesAPI = async () => {
  try {
    const response = await axiosInstance.get(`/api/user/game/lifelines`);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error getting lifelines:", error);
    throw new Error(error.response?.data?.message || "Failed to get lifelines");
  }
};

export const getCompletedGamesAPI = async (page: number = 1, per_page: number = 10) => {
  try {
    const response = await axiosInstance.get("/api/user/game/completed-games", {
      params: { page, per_page },
    });
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error getting completed games:", error);
    throw new Error(error.response?.data?.message || "Failed to get completed games");
  }
};

export const resetPendingGameAPI = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/reset`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error resetting game:", error);
    throw new Error(error.response?.data?.message || "Failed to reset game");
  }
};

export const searchParticipantsAPI = async (text: string) => {
  try {
    const response = await axiosInstance.get(`/api/user/game/search-participants`, {
      params: { text },
    });
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error searching participants:", error);
    throw new Error(error.response?.data?.message || "Failed to search participants");
  }
};

export const getPreviouslyPlayedParticipantsAPI = async (text?: string) => {
  try {
    const response = await axiosInstance.get(`/api/user/game/friends-list`, {});
    if (!response.data.status) {
      throw new Error(response.data.message);
    }

    // Preserve existing consumer contract: response.data.users
    const users = (response.data?.data?.users ?? response.data?.data ?? response.data?.users ?? []) as any[];
    const trimmedText = (text || "").trim().toLowerCase();

    if (!trimmedText) {
      return {
        ...response.data,
        data: {
          ...(response.data?.data || {}),
          users,
        },
      };
    }

    const filteredUsers = users.filter((user: any) => {
      const name = String(user?.full_name || "").toLowerCase();
      const email = String(user?.email || "").toLowerCase();
      const phone = String(user?.phone_number || "").toLowerCase();
      return name.includes(trimmedText) || email.includes(trimmedText) || phone.includes(trimmedText);
    });

    return {
      ...response.data,
      data: {
        ...(response.data?.data || {}),
        users: filteredUsers,
      },
    };
  } catch (error: any) {
    console.error("Error getting previously played participants:", error);
    throw new Error(error.response?.data?.message || "Failed to get previously played participants");
  }
};

// Use lifeline API
export const useLifelineAPI = async (payload: {
  game_id?: string | null;
  question_id?: string | null;
  team_id?: string | null;
  lifeline_id: string | null;
  team_lifeline_id?: string | null;
  user_id?: string | string[];
  opponent_team_id?: string | null;
  opponent_team_lifeline_id?: string | null;
  answered_team_id?: string | null;
  points?: number | null;
  category_id?: string | null;
}) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/update-lifeline-use`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error using lifeline:", error);
    throw new Error(error.response?.data?.message || "Failed to use lifeline");
  }
};

export const add1000QuestionAPI = async (payload: {
  game_id?: string | null;
  question_id?: string | null;
  team_id?: string | null;
  lifeline_id: string | null;
}) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/add-1000-question`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error adding 1,000 question:", error);
    throw new Error(error.response?.data?.message || "Failed to add 1,000 question");
  }
};

export const addMysteryWildcardQuestionAPI = async (payload: {
  game_id?: string | null;
  question_id?: string | null;
  team_id?: string | null;
  lifeline_id: string | null;
}) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/add-mystery-wildcard-question`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error adding mystery wildcard question:", error);
    throw new Error(error.response?.data?.message || "Failed to add mystery wildcard question");
  }
};

// Update team points (scoreboard edit)
export const updateTeamPointsAPI = async (payload: { game_id: string; team_id: string; points: string | number }) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/update-team-points`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error updating team points:", error);
    throw new Error(error.response?.data?.message || "Failed to update team points");
  }
};

interface ValidateUsersPayload {
  participants: {
    user_id?: string;
    full_name: string;
    email: string;
    phone_number: string;
  }[];
}

export const validateUsersAPI = async (payload: ValidateUsersPayload) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/validate-users`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error validating users:", error);
    throw new Error(error.response?.data?.message || "Failed to validate users");
  }
};

interface ValidateCategoriesPayload {
  game_categories: {
    category_id: string;
  }[];
}

export const validateCategoriesAPI = async (payload: ValidateCategoriesPayload) => {
  try {
    const response = await axiosInstance.post(`/api/user/game/validate-categories`, payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error validating categories:", error);
    throw new Error(error.response?.data?.message || "Failed to validate categories");
  }
};

export const getMyAchievementsAPI = async () => {
  try {
    const response = await axiosInstance.get("/api/user/game/my-achievements", {});
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error fetching my achievements:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch my achievements");
  }
};

export const setDefaultAchievementAPI = async (payload: any) => {
  try {
    const response = await axiosInstance.post("api/user/game/set-default-achievement", payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error setting default achievement:", error);
    throw new Error(error.response?.data?.message || "Failed to set default achievement");
  }
};

export const addAsFriendsAPI = async (payload: { friend_id: string }) => {
  try {
    const response = await axiosInstance.post("/api/user/game/add-as-friends", payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error adding as friend:", error);
    throw new Error(error.response?.data?.message || "Failed to add as friend");
  }
};

export const removeFromFriendsAPI = async (payload: { friend_id: string }) => {
  try {
    const response = await axiosInstance.post("/api/user/game/remove-from-friends", payload);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error removing from friends:", error);
    throw new Error(error.response?.data?.message || "Failed to remove from friends");
  }
};

export type QrCodeTimerSettings = {
  easy: number;
  medium: number;
  hard: number;
};

export const getQrCodeTimerSettingsAPI = async () => {
  try {
    const response = await axiosInstance.get("/api/user/game/qr-code-timer-settings");
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error getting QR code timer settings:", error);
    throw new Error(error.response?.data?.message || "Failed to get QR code timer settings");
  }
};
